import { AddressClient } from './AddressClient';
import { BadgeClient } from './BadgeClient';
import { FacilityClient } from './FacilityClient';
import { KlaviyoClient } from './KlaviyoClient';
import { SlackClient } from './SlackClient';
import { TagClient } from './TagClient';
import { TeamClient } from './TeamClient';
import { UserClient } from './UserClient';

export const clients = {
  address: new AddressClient('/addresses'),
  team: new TeamClient('/teams'),
  user: new UserClient('/users'),
  tag: new TagClient('/tags'),
  badge: new BadgeClient('/badges'),
  facility: new FacilityClient('/facilities'),
  slack: new SlackClient('/slack'),
  klaviyo: new KlaviyoClient('/klaviyo'),
};
